import { Center } from '@chakra-ui/react';
import { DatePicker } from '@kula-ai/components';
import dayjs from 'dayjs';
import { KText } from '@/ui-library/components';

interface DatePopOverProps {
  meta?: { value?: string };
  date?: Date | string;
  setDate?: (date: Date | undefined, onClose: () => void) => void;
  dateFormat?: string;
}

// Today and everything before it stays unselectable, as the react-day-picker
// version did with `disabled: [today, { before: today }]`.
const firstSelectableDate = () => dayjs().add(1, 'day').startOf('day').toDate();

// The picker closes itself on select; callers still take an onClose callback.
const noop = () => {};

export const DatePopOver = ({
  meta = {},
  date = '',
  setDate = () => {},
  dateFormat = 'DD/MM/YYYY',
}: DatePopOverProps) => {
  const isCustom = meta?.value === 'custom';

  return (
    <Center w="25%" bg={isCustom ? 'ats-primary' : undefined}>
      <DatePicker
        mode="single"
        value={date ? new Date(date) : null}
        onChange={(selected) => setDate(selected, noop)}
        // Sunday-first matches WEEK_START_DAY and the picker this replaced;
        // kula's calendar defaults to Monday.
        calendarProps={{ minDate: firstSelectableDate(), weekStartsOn: 0 }}
        renderTrigger={({ onClick }) => (
          <Center flexDir="column" cursor="pointer" onClick={onClick}>
            <KText
              size="sm-medium"
              color={isCustom ? 'base-white' : 'secondary-900'}
            >
              Until
            </KText>
            <KText
              size="sm-medium"
              color={isCustom ? 'base-white' : 'secondary-700'}
            >
              {/* dayjs tokens come from the account date format, so the label is
                  formatted here rather than with the picker's date-fns value. */}
              {date ? dayjs(date).format(dateFormat) : 'Select Date'}
            </KText>
          </Center>
        )}
      />
    </Center>
  );
};
